import React, { useState } from "react";

import SettingsTutorial from "../SettingsTutorial";
import LoadingSpinner from "../../../../common/LoadingSpinner";
import Settings from "../../../../common/mypage/user-settings/Settings";
import RequestCompleteNotice from "../../../../common/settings-modal/RequestCompleteNotice";
import TopicSettingsItem from "../../../../common/mypage/user-settings/TopicSettingsItem";

import ImageTopics from "../../../../assets/img/topics-setsumei.webp";

import { useAppSelector } from "../../../../redux/hooks";
import { getAuthToken } from "../../../../redux/reducers/auth";
import { getLinkedPages } from "../../../../redux/reducers/user";

import { PageVisibility } from "../../../../utils/PageVisibility";
import {
  useGetTopics,
  useUpdateTopics,
  useRequestTopicApproval,
} from "../../../../utils/useTopics";

const TopicSettingsContainer: React.FC = () => {
  const auth_token = useAppSelector(getAuthToken);
  const linked_pages = useAppSelector(getLinkedPages);
  const queryArgs = {
    auth_token: auth_token,
    per: -1,
    id: linked_pages?.topics ?? null,
  };

  const [isComplete, setIsComplete] = useState<boolean>(false);
  const [currentMenu, setCurrentMenu] = useState<number>();

  const { topicsData: topics, isLoading } = useGetTopics(queryArgs);

  const { mutate, mutateLoading } = useUpdateTopics(["topics", queryArgs]);
  const { request, requestLoading } = useRequestTopicApproval([
    "topics",
    queryArgs,
  ]);

  const tutorial = (
    <SettingsTutorial
      img_src={ImageTopics}
      title="トピックスとは？"
      explanation="eスポーツに関するコラムなどの情報をSELeCTに掲載できます。eスポーツに興味関心度の高いユーザーへ情報を拡散することができます。公開されたトピックスはSELeCT公式より紹介させていただく場合がございます。"
    />
  );

  const completeHandler = () => {
    setIsComplete(false);
  };

  const handlePrivate = async (id?: string) => {
    if (auth_token && id)
      mutate({
        auth_token: auth_token,
        update: {
          sonic_id: id,
          sonic_status: PageVisibility.NotPubliclyVisible,
        },
      });
  };

  const handlePublish = async (id?: string) => {
    if (auth_token && id) request({ auth_token: auth_token, id: id });
  };

  if (isComplete) {
    return (
      <RequestCompleteNotice
        handler={completeHandler}
        title="公開申請完了"
        text={
          "公開申請が完了しました。\nこれより審査を開始します。\n結果通知までしばらくお待ちください。"
        }
        sub_text="※内容によっては数日お時間をいただく可能性がございます。"
      />
    );
  } else if (isLoading || mutateLoading || requestLoading) {
    return <LoadingSpinner space={1} />;
  } else {
    return (
      <Settings
        type="トピックス"
        description={`トピックスを作成してeスポーツに関する新たな情報を共有しましょう。\nチームの紹介記事や新作ゲームのレビューなど気軽に作成してください。`}
        link="/mypage/topic-settings/create"
        tutorial={tutorial}
        currentMenu={currentMenu}
      >
        {topics.items.length > 0
          ? topics.items.map((topic, i) => (
              <TopicSettingsItem
                key={i}
                id={topic.id}
                name={topic.name}
                status={topic.status}
                handleMenu={() =>
                  setCurrentMenu(i === currentMenu ? undefined : i)
                }
                handlePublish={handlePublish}
                handlePrivate={handlePrivate}
                edit_link={`/mypage/topic-settings/${topic.id}`}
                detail_link={`/topics/${topic.id}`}
                isMenuOpen={currentMenu === i ? true : false}
                isOwner={true}
                start_date={topic.start_date}
                img_src={topic.imgs?.[0]?.medium?.url}
              />
            ))
          : null}
      </Settings>
    );
  }
};

export default TopicSettingsContainer;
